<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.1362 6.26074C14.4291 5.9679 14.9039 5.96801 15.1968 6.26074C15.4897 6.55364 15.4897 7.0284 15.1968 7.32129L8.78076 13.7383C8.48798 14.0311 8.01313 14.0308 7.72021 13.7383L4.80322 10.8213C4.51033 10.5284 4.51033 10.0536 4.80322 9.76074C5.09612 9.46785 5.57088 9.46785 5.86377 9.76074L8.24951 12.1465L14.1362 6.26074Z"
      fill="#43A047" />
  </svg>
</template>
